(ns frontend.view.components.timeline.entry.webentry-resolve
  (:require [frontend.view.components.timeline.entry.declaration :as te]
            [frontend.view.components.timeline.entry.default-item :as default]
            [frontend.view.components.timeline.db :as db]
            [frontend.view.components.timeline.entry.utils :as utils]
            [clojure.set :as set]
            [clojure.string :as string]
            [cljs.reader :as edn]
            [potpuri.core :refer [fn-> fn->>]]
            [common.localization :as loc]
            [common.entity :as zap-entity]
            [frontend.utils :as main-utils]
            [frontend.state.current-session :as session]))

;;dashboard => Deal X created through web form / Company Y data updated
;;deal timeline => Deal X created / Company Y data updated
;;company timeline => Company Y created / data updated through web form
;;person timeline => James Bond created / data updated through web form
(defn title-generator [type target-person entry]
  (let [company-name-change (-> entry
                                :audit/target-changes
                                :asset/name
                                :set)
        company-name (->> entry :audit/target
                          (get @session/entities)
                          :asset/name)
        deal-name-change (->> entry
                              :audit/references-changes
                              vals
                              (filter (fn-> :oppo/name :set))
                              first
                              :oppo/name
                              :set)
        new-person? (->> target-person
                         :db/id
                         (get (-> entry :audit/references-changes))
                         :person/universal-email-address
                         :set)
        person-name (str (:person/first-name target-person)
                         " "
                         (:person/last-name target-person))]
    (cond (and (= type :entity.type/oppo)
               deal-name-change)
          (loc/tr :op.webentry/resolve-deal-created [deal-name-change])
          (= type :entity.type/oppo)
          (loc/tr :op.webentry/resolve-company-updated [company-name])
          (and (= type :entity.type/company)
               company-name-change)
          (loc/tr :op.webentry/resolve-company-created [company-name])
          (= type :entity.type/company)
          (loc/tr :op.webentry/resolve-company-updated [company-name])
          (and (= type :dashboard)
               deal-name-change)
          (loc/tr :op.webentry/resolve-deal-created [deal-name-change])
          (= type :dashboard)
          (loc/tr :op.webentry/resolve-company-updated [deal-name-change])
          (and (= type :entity.type/person)
               company-name-change)
          (loc/tr :op.webentry/resolve-person-created [person-name])
          (= type :entity.type/person)
          (loc/tr :op.webentry/resolve-person-updated [person-name])
          :else
          (default/title-generator entry))))

(defn body-generator [entry])                               ;;empty for now

(defmethod te/timeline-entry-view :op.webentry/resolve [{entry :entry accounts :accounts target-person :target-person target-type :target-type op-args :op-args}]
  [default/timeline-item-view entry (partial title-generator target-type target-person) body-generator default/timestamp-generator])
